import styled from 'styled-components'

const Wrapper = styled.div`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    display: ${({ enableFlex }) => (enableFlex ? 'flex' : 'block')};
    flex-wrap: wrap;
  }
  padding-top: ${props => props.isAFSProduct && '44px'};
`

const FullWidth = styled.div`
  width: 100%;
`

export { Wrapper, FullWidth }
